<template>
  <document-list :config="config" :isLoading="isLoading" :height="height"></document-list>
</template>

<script>
import DocumentList from './DocumentList';
import loaderMixin from '@/mixins/loaderMixin';
export default {
  mixins: [loaderMixin],
  name: 'Favorites',
  props: {
    config: Object,
    height: Number, // optional height of this widget
  },
  created() {
    this.config.favoritesOnly = true;
  },
  components: {
    DocumentList,
  },
};
</script>

<style></style>
